import { AxiosError } from 'axios';

import { ZEE_FEATURE_LOCKS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ZeeFeatureLocks } from '@/types/feature.locks.type';
import { ApiResponse } from '@/types/response.type';

const getZeeFeatureLocks = async (): Promise<ApiResponse<ZeeFeatureLocks>> => {
  try {
    const response = await apiManager.get(`${ZEE_FEATURE_LOCKS_API_URL}`, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getZeeFeatureLocks;
